import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";

const RenameFileModal = ({ open, onOpenChange, file, onConfirm, loading = false }) => {
  const [newName, setNewName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (file && open) {
      setNewName(file.name || "");
      setError("");
    }
  }, [file, open]);

  const handleRename = () => {
    const trimmedName = newName.trim();
    if (!trimmedName) {
      setError("File name cannot be empty");
      return;
    }

    if (trimmedName === file.name) {
      setError("New name must be different from current name");
      return;
    }

    // Validate file name (no special characters)
    if (!/^[a-zA-Z0-9._\-\s()]+$/.test(trimmedName)) {
      setError("File name contains invalid characters. Only letters, numbers, dots, hyphens, underscores, spaces and parentheses allowed.");
      return;
    }

    onConfirm(trimmedName);
    onOpenChange(false);
    setNewName("");
    setError("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      handleRename();
    }
    if (e.key === "Escape") {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Rename File</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <label htmlFor="file-name" className="text-sm font-medium text-gray-700">
              Current Name:
            </label>
            <p className="text-sm text-gray-600 bg-gray-50 p-2 rounded border border-gray-200">
              {file?.name}
            </p>
          </div>
          <div className="grid gap-2">
            <label htmlFor="new-name" className="text-sm font-medium text-gray-700">
              New Name:
            </label>
            <Input
              id="new-name"
              type="text"
              value={newName}
              onChange={(e) => {
                setNewName(e.target.value);
                setError("");
              }}
              onKeyDown={handleKeyDown}
              placeholder="Enter new file name"
              disabled={loading}
              autoFocus
            />
            {error && <p className="text-sm text-red-600">{error}</p>}
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleRename}
            disabled={loading || !newName.trim()}
            className="bg-blue-600 hover:bg-blue-700 bg-[#0071bd] text-white"
          >
            {loading ? "Renaming..." : "Rename"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RenameFileModal;
